import { render, staticRenderFns } from "./ProductPlaceholderImage.vue?vue&type=template&id=3a104233&"
import script from "./ProductPlaceholderImage.vue?vue&type=script&lang=js&"
export * from "./ProductPlaceholderImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports